; (function vpAccessibilityMobileFixesV1() {
  'use strict';

  if (window.__vpAccessibilityMobileFixesV1) return;
  window.__vpAccessibilityMobileFixesV1 = true;

  var lastMenuOpen = false;
  var menuReturnFocus = null;
  var uid = 0;

  function visible(element) {
    if (!element || element.hidden || element.getAttribute('aria-hidden') === 'true') return false;
    var style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && !!(
      element.offsetWidth || element.offsetHeight || element.getClientRects().length
    );
  }

  function focusable(container) {
    if (!container) return [];
    return Array.prototype.filter.call(
      container.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'),
      visible
    );
  }

  function ensureId(element, prefix) {
    if (!element) return '';
    if (!element.id) {
      uid += 1;
      element.id = prefix + '-' + uid;
    }
    return element.id;
  }

  function setButtonType(button) {
    if (button && button.tagName === 'BUTTON' && !button.hasAttribute('type')) button.type = 'button';
  }

  function enhanceMobileMenu() {
    var opener = document.querySelector('.navbar-toggler');
    var menu = document.getElementById('mobileMenu');
    if (!opener || !menu) return;

    opener.setAttribute('aria-controls', 'mobileMenu');
    if (opener.tagName !== 'BUTTON') {
      opener.setAttribute('role', 'button');
      opener.setAttribute('tabindex', '0');
      if (opener.getAttribute('data-vp-keyboard-button') !== 'true') {
        opener.setAttribute('data-vp-keyboard-button', 'true');
        opener.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            opener.click();
          }
        });
      }
    } else {
      setButtonType(opener);
    }

    menu.setAttribute('role', 'dialog');
    menu.setAttribute('aria-modal', 'true');
    menu.setAttribute('aria-label', 'Main menu');

    var close = menu.querySelector('.close-btn');
    if (close) close.setAttribute('aria-label', 'Close menu');

    if (menu.getAttribute('data-vp-focus-trap') !== 'true') {
      menu.setAttribute('data-vp-focus-trap', 'true');
      menu.addEventListener('keydown', function (event) {
        if (!document.body.classList.contains('nav-open')) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          if (close && typeof close.click === 'function') close.click();
          return;
        }
        if (event.key !== 'Tab') return;
        var items = focusable(menu);
        if (!items.length) {
          event.preventDefault();
          return;
        }
        var first = items[0];
        var last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }

    Array.prototype.forEach.call(
      menu.querySelectorAll('button.toggle-level,button.list-menu__item.toggle'),
      function (button) {
        setButtonType(button);
        var panel = button.nextElementSibling;
        if (!panel) return;
        var panelId = ensureId(panel, 'vp-mobile-submenu');
        button.setAttribute('aria-controls', panelId);
        var expanded = button.classList.contains('open-menu-drop');
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        var panelHidden = expanded ? 'false' : 'true';
        if (panel.getAttribute('aria-hidden') !== panelHidden) panel.setAttribute('aria-hidden', panelHidden);
      }
    );

    var open = document.body.classList.contains('nav-open');
    opener.setAttribute('aria-expanded', open ? 'true' : 'false');
    var menuHidden = open ? 'false' : 'true';
    if (menu.getAttribute('aria-hidden') !== menuHidden) menu.setAttribute('aria-hidden', menuHidden);

    if (open && !lastMenuOpen) {
      menuReturnFocus = document.activeElement === document.body ? opener : document.activeElement;
      window.setTimeout(function () {
        var target = close || focusable(menu)[0];
        if (target && typeof target.focus === 'function') target.focus();
      }, 60);
    }

    if (!open && lastMenuOpen && menuReturnFocus && typeof menuReturnFocus.focus === 'function') {
      var returnFocusTarget = menuReturnFocus;
      menuReturnFocus = null;
      window.setTimeout(function () {
        if (returnFocusTarget.isConnected) returnFocusTarget.focus();
      }, 0);
    }
    lastMenuOpen = open;
  }

  function enhanceSearch() {
    var headerBox = document.querySelector('.yv-header-searchbar-box');
    if (headerBox) {
      var input = headerBox.querySelector('input.search-input');
      var label = headerBox.querySelector('label.visually-hidden');
      if (input) {
        if (!input.id || input.id === 'search-drawer-query-input') input.id = 'header-search-query-input';
        input.setAttribute('aria-label', 'Search products');
        if (label) label.setAttribute('for', input.id);
      }
      var clear = headerBox.querySelector('button[data-searchbar-cross]');
      if (clear) {
        setButtonType(clear);
        clear.setAttribute('aria-label', 'Clear search');
      }
    }

    Array.prototype.forEach.call(document.querySelectorAll('.yv-search-drawer-close'), function (button) {
      setButtonType(button);
      if (!button.getAttribute('aria-label')) button.setAttribute('aria-label', 'Close search');
    });

    var drawer = document.querySelector('.search-bar-container');
    if (drawer) {
      drawer.setAttribute('role', 'dialog');
      drawer.setAttribute('aria-modal', 'true');
      drawer.setAttribute('aria-label', 'Search');
      var drawerHidden = document.body.classList.contains('addsearch') ? 'false' : 'true';
      if (drawer.getAttribute('aria-hidden') !== drawerHidden) drawer.setAttribute('aria-hidden', drawerHidden);
    }
  }

  function enhanceProductControls() {
    Array.prototype.forEach.call(document.querySelectorAll('#sizeChartClose'), function (button) {
      setButtonType(button);
      button.setAttribute('aria-label', 'Close size chart');
    });

    Array.prototype.forEach.call(document.querySelectorAll('select.productOption.dropdown-selected'), function (select) {
      if (select.hasAttribute('aria-label') || select.hasAttribute('aria-labelledby')) return;
      var wrapper = select.closest('.product-option-selector');
      var title = wrapper ? wrapper.querySelector('.yv-variant-title') : null;
      var label = title ? title.textContent.replace(/\s+/g, ' ').trim() : '';
      select.setAttribute('aria-label', label || 'Product option');
    });

    Array.prototype.forEach.call(document.querySelectorAll('select.selling_plan_attribute'), function (select) {
      if (!select.hasAttribute('aria-label') && !select.hasAttribute('aria-labelledby')) {
        select.setAttribute('aria-label', 'Purchase option');
      }
    });
  }

  function enhanceCartControls() {
    Array.prototype.forEach.call(document.querySelectorAll('.sd_mini_removeproduct'), function (button) {
      setButtonType(button);
      var item = button.closest('.yv-mini-cart-item,.mini-cart-item,.cart-item');
      var product = item ? item.querySelector('.yv-product-title') : null;
      var name = product ? product.textContent.replace(/\s+/g, ' ').trim() : '';
      button.setAttribute('aria-label', name ? 'Remove ' + name + ' from cart' : 'Remove item from cart');
    });

    Array.prototype.forEach.call(document.querySelectorAll('.yv_side_drawer_close'), function (button) {
      setButtonType(button);
      button.setAttribute('aria-label', 'Close panel');
    });

    Array.prototype.forEach.call(document.querySelectorAll('.cart-icon'), function (link) {
      if (!link.getAttribute('aria-label')) link.setAttribute('aria-label', 'Cart');
    });

    var assurance = document.querySelector('.vp-checkout-assurance');
    var checkout = document.querySelector('#cartCheckout,[name="checkout"],.checkout-btn[href*="checkout"]');
    if (assurance && checkout) {
      var assuranceId = ensureId(assurance, 'vp-checkout-assurance');
      var describedBy = (checkout.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
      if (describedBy.indexOf(assuranceId) === -1) describedBy.push(assuranceId);
      checkout.setAttribute('aria-describedby', describedBy.join(' '));
    }
  }

  function addFocusStyles() {
    if (document.getElementById('vp-a11y-mobile-styles')) return;
    var style = document.createElement('style');
    style.id = 'vp-a11y-mobile-styles';
    style.textContent = [
      '.navbar-toggler:focus-visible,.side-menu a:focus-visible,.side-menu button:focus-visible,.yv-header-searchbar button:focus-visible,.yv-header-searchbar input:focus-visible,.yv-search-drawer-close:focus-visible,.Sd_addProduct:focus-visible,#cartCheckout:focus-visible,.checkout-btn:focus-visible{outline:3px solid #1b73cc!important;outline-offset:3px!important;}',
      '@media(max-width:1024px){.side-menu .list-menu__item,.side-menu .toggle-level,.side-menu .close-btn{min-height:44px;}.Sd_addProduct,#cartCheckout,.checkout-btn{min-height:48px;}}',
      '@media(prefers-reduced-motion:reduce){.side-menu,.shopify-section-main-header,.yv_side_drawer_wrapper{transition:none!important;scroll-behavior:auto!important;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function enhance() {
    enhanceMobileMenu();
    enhanceSearch();
    enhanceProductControls();
    enhanceCartControls();
    addFocusStyles();
  }

  function observe() {
    var enhanceQueued = false;
    var pendingEnhancements = 0;
    function runEnhancement() {
      var requested = pendingEnhancements;
      pendingEnhancements = 0;
      enhanceQueued = false;
      if (requested & 1) enhanceMobileMenu();
      if (requested & 2) enhanceSearch();
      if (requested & 4) enhanceProductControls();
      if (requested & 8) enhanceCartControls();
      if (requested & 16) addFocusStyles();
    }
    var observer = new MutationObserver(function (records) {
      Array.prototype.forEach.call(records, function (record) {
        if (pendingEnhancements === 31) return;
        if (record.type === 'childList') {
          pendingEnhancements |= 31;
          return;
        }
        var target = record.target;
        if (target === document.body) {
          pendingEnhancements |= 3;
          return;
        }
        if (!target || typeof target.closest !== 'function') {
          pendingEnhancements |= 31;
          return;
        }
        if (target.closest('#mobileMenu,.navbar-toggler')) pendingEnhancements |= 1;
        if (target.closest('.yv-header-searchbar-box,.yv-search-drawer-close,.search-bar-container')) pendingEnhancements |= 2;
        if (target.closest('#sizeChartClose,.product-option-selector,.yv-variant-title,select.productOption.dropdown-selected,select.selling_plan_attribute')) pendingEnhancements |= 4;
        if (target.closest('.sd_mini_removeproduct,.yv-mini-cart-item,.mini-cart-item,.cart-item,.yv-product-title,.yv_side_drawer_close,.cart-icon,.vp-checkout-assurance,#cartCheckout,[name="checkout"],.checkout-btn[href*="checkout"]')) pendingEnhancements |= 8;
      });
      if (!pendingEnhancements || enhanceQueued) return;
      enhanceQueued = true;
      if (typeof window.requestAnimationFrame === 'function') window.requestAnimationFrame(runEnhancement);
      else window.setTimeout(runEnhancement, 16);
    });
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      enhance();
      observe();
    }, { once: true });
  } else {
    enhance();
    observe();
  }
})();